import { useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";

export default function Layout({ children }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="shell">
      <Sidebar open={open} onClose={() => setOpen(false)} />
      <div style={{ minWidth: 0 }}>
        <Header onMenu={() => setOpen(true)} />
        <main className="content">{children}</main>
      </div>
    </div>
  );
}
